import CircleAlertIcon from '@persona-id/design-tokens/icons/CircleAlertIcon';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom-v5-compat';

import Banner from 'dashboard/components-lib/Banner';
import { RootState } from 'dashboard/redux/store';

interface SetupMfaBannerProps {
  isLoggedIn: boolean;
}

const SetupMfaBanner = ({ isLoggedIn }: SetupMfaBannerProps) => {
  const mfaShouldBeConfigured = useSelector<RootState, boolean>((state) => {
    const mfaRequired = state.organization.organization?.attributes['mfa-required-at'] != null;
    const mfaNotConfigured =
      state.currentUser.currentUser?.attributes?.['available-mfa-methods']?.length === 0;
    const samlEnabled = state.organization.organization?.attributes['has-saml-enabled'] ?? false;
    // email address starts with persona-admin+ and ends with @withpersona.com
    const currentUserAdminServiceAccount =
      state.currentUser.currentUser?.attributes?.['email-address']?.startsWith('persona-admin+') &&
      state.currentUser.currentUser?.attributes?.['email-address']?.endsWith('@withpersona.com');

    return !currentUserAdminServiceAccount && !samlEnabled && mfaRequired && mfaNotConfigured;
  });

  return (
    <>
      {isLoggedIn && mfaShouldBeConfigured && (
        <Banner icon={<CircleAlertIcon size={24} />}>
          Your organization requires two-factor authentication.{' '}
          <Link to='/dashboard/user/profile/security'>
            Set up two-factor authentication to avoid being locked out of your account.
          </Link>
        </Banner>
      )}
    </>
  );
};

export default SetupMfaBanner;
